import { Box, Typography } from "@mui/joy";

interface NoCandidatesProps {
  title?: string;
  message?: string;
}

const NoCandidates: React.FC<NoCandidatesProps> = ({ 
  title = "No people have applied yet",
  message = "Check back later for new applications"
}) => {
  return (
    <Box sx={{ textAlign: "center", py: 4 }}>
      <Typography level="h4" sx={{ mb: 2 }}>
        {title}
      </Typography>
      <Typography level="body-md" sx={{ color: "#666" }}>
        {message}
      </Typography>
    </Box>
  );
};

export default NoCandidates; 